import { motion } from 'motion/react';
import { type ReactNode } from 'react';
import { EASE_OUT } from '@/lib/motion';

/** Fade + 8px rise on mount; key it by route to replay on navigation. */
export function PageTransition({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, ease: EASE_OUT }}
    >
      {children}
    </motion.div>
  );
}
